module.exports = __webpack_public_path__ + "static/media/bonair1.2b9bee9d.JPG";